export default {"src":"/_next/static/media/Arrow-right-white.7c17fea4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};